export default __webpack_public_path__ + "static/media/myNextFoot.08b78b65.svg";